<template>
  <el-form
    ref="PersonalCardPaymentInformations"
    class="PaymentMethod__Form--Custom Form--Custom"
  >
    <div class="payment-card">
      <p class="subtitle">
        Preencha os dados do seu cartão Personal Card conforme aplicativo.
        <br />
        <span class="note">* Já preenchemos os primeiros 9 dígitos para facilitar 😊</span>
      </p>

      <div class="card-input-box">
        <div class="card-header">
          <label>Preencha o número do cartão</label>
          <div class="card-number-inputs">
            <span class="filled">62984</span>
            <span class="filled">6006</span>
            <el-input
              v-model="cardPart3"
              placeholder="Digite"
              maxlength="4"
              size="small"
              class="card-input"
            />
            <el-input
              v-model="cardPart4"
              placeholder="Digite"
              maxlength="4"
              size="small"
              class="card-input"
            />
          </div>
          <small class="info">* Preencha todos os dados do cartão.</small>
        </div>

        <div class="card-password">
          <label>Digite a senha:</label>
          <div>
            <el-input
              v-model="password"
              placeholder="1234"
              maxlength="4"
              size="small"
              class="password-input"
            />
          </div>
          <small class="info">* A senha são os 4 primeiros dígitos do CPF do beneficiário</small>
        </div>

        <img
          src="@/assets/icons/paymentOptions/personal_card.png"
          alt="Personal Card"
          class="logo"
        />
      </div>
    </div>
  </el-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'PersonalCardForm',
  data() {
    return {
      cardPart1: '62984',
      cardPart2: '6006',
      cardPart3: '',
      cardPart4: '',
      password: ''
    }
  },
  computed: {
    ...mapGetters(['AppConfig', 'Checkout', 'CheckoutConfig'])
  },
  mounted () {
    this.$emit('form-mounted', this)
  },
  methods: {
    ...mapActions([
      'UpdatePaymentState',
      'setAnalyticsError',
      'setCheckoutStatus'
    ]),
    async generateHash (card1, card2, card3, card4, pass) {
      if (card1 && card2 && card3 && card4 && pass) {
        try {
          let paymentHash = null
          const personalCardInformation = { card1, card2, card3, card4, pass }
          const json = JSON.stringify(personalCardInformation)
          paymentHash = btoa(json)
          return {
            successfullyCreated: true,
            hash: paymentHash
          }
        } catch (error) {
          this.setAnalyticsError({
            id: `PERSONAL_CARD_VALIDATION_ERROR`,
            method: 'generateHash',
            error: `createPaymentHash: ${error.message}`,
            fatal: true
          })
          this.setCheckoutStatus({
            PaymentOptions: {
              update: 'INVALID_PERSONAL_CARD'
            }
          })
        }
      } else {
        return null
      }
    },
    async generateHashAndUpdatePaymentInfo () {
      var paymentHash = await this.generateHash(
        this.cardPart1,
        this.cardPart2,
        this.cardPart3,
        this.cardPart4,
        this.password
      )

      this.UpdatePaymentState({
        default_hash: paymentHash,
        last_four_numbers: this.cardPart4
      })
    }
  }
}
</script>

<style scoped>
.payment-card {
  font-family: Arial, sans-serif;
  max-width: 500px;
  margin: 20px auto;
}

.subtitle {
  font-size: 14px;
  color: #666;
}

.note {
  font-size: 13px;
  color: #58a;
}

.card-input-box {
  background-color: #007873;
  color: white;
  border-radius: 12px;
  padding: 40px 20px;
  position: relative;
  overflow: hidden;
  z-index: 1;
}

.card-header label,
.card-password label {
  font-weight: bold;
  display: block;
  margin-bottom: 6px;
  margin-top: 20px;
}

.card-number-inputs {
  display: flex;
  gap: 6px;
  margin-bottom: 6px;
  align-items: center;
}

.filled {
  background: #007873;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-weight: bold;
  min-width: 50px;
  text-align: center;
}

.card-input >>> .el-input__inner,
.password-input >>> .el-input__inner {
  background: rgb(0, 162, 173);
  color: white;
  border: none;
  font-size: 14px;
  border-radius: 4px;
  padding: 4px;
}

.card-input {
  width: 60px;
}

.password-input {
  width: 60px;
  margin-bottom: 6px;
  margin-top: 10px;
}

.info {
  font-size: 12px;
  color: #d0f5f4;
}

.logo {
  position: absolute;
  top: 20px;
  right: 20px;
  height: 40px;
  opacity: 0.8;
  margin-top: 40px;
}

.card-input-box::before,
.card-input-box::after {
  content: '';
  position: absolute;
  border-radius: 50%;
  background: rgba(0, 162, 173, 0.6);
  z-index: 0;
}

.card-input-box::before {
  width: 140px;
  height: 140px;
  bottom: 20px;
  right: -20px;
}

.card-input-box::after {
  width: 100px;
  height: 100px;
  bottom: -20px;
  right: -20px;
}

::v-deep(.el-input__inner::placeholder) {
  color: white;
  opacity: 0.7;
}
</style>
